export const schema = {
  models: {
    User: {
      name: "User",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        email: {
          name: "email",
          isArray: false,
          type: "AWSEmail",
          isRequired: true,
          attributes: [],
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "UserStatus",
          },
          isRequired: true,
          attributes: [],
        },
        athleteId: {
          name: "athleteId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        coach: {
          name: "coach",
          isArray: true,
          type: {
            model: "TeamCoach",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "user",
          },
        },
        judgeType: {
          name: "judgeType",
          isArray: true,
          type: {
            enum: "JudgeType",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
        },
        judgeTypeProxy: {
          name: "judgeTypeProxy",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        judgeSessions: {
          name: "judgeSessions",
          isArray: true,
          type: {
            model: "SessionJudge",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "user",
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        name: {
          name: "name",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        firstName: {
          name: "firstName",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        lastName: {
          name: "lastName",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        location: {
          name: "location",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        handle: {
          name: "handle",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        colors: {
          name: "colors",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        profileImg: {
          name: "profileImg",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        googleId: {
          name: "googleId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        facebookId: {
          name: "facebookId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        appleId: {
          name: "appleId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        cognitoId: {
          name: "cognitoId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Users",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "searchable",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "UserByEmail",
            fields: ["email"],
            queryField: "UserByEmail",
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
              {
                allow: "private",
                provider: "iam",
                operations: ["create", "update", "read"],
              },
            ],
          },
        },
      ],
    },
    Session: {
      name: "Session",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        sessionKey: {
          name: "sessionKey",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        name: {
          name: "name",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        type: {
          name: "type",
          isArray: false,
          type: {
            enum: "SessionType",
          },
          isRequired: true,
          attributes: [],
        },
        gender: {
          name: "gender",
          isArray: false,
          type: {
            enum: "GenderType",
          },
          isRequired: false,
          attributes: [],
        },
        judging: {
          name: "judging",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        judgingRequired: {
          name: "judgingRequired",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        competition: {
          name: "competition",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        apparatus: {
          name: "apparatus",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        access: {
          name: "access",
          isArray: false,
          type: {
            enum: "SessionAccess",
          },
          isRequired: true,
          attributes: [],
        },
        startAt: {
          name: "startAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        endAt: {
          name: "endAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "SessionStatus",
          },
          isRequired: true,
          attributes: [],
        },
        teamScoring: {
          name: "teamScoring",
          isArray: false,
          type: {
            enum: "SessionTeamScoreType",
          },
          isRequired: false,
          attributes: [],
        },
        alternating: {
          name: "alternating",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        judgePanel: {
          name: "judgePanel",
          isArray: false,
          type: {
            enum: "JudgePanelType",
          },
          isRequired: false,
          attributes: [],
        },
        lineups: {
          name: "lineups",
          isArray: true,
          type: {
            model: "Lineup",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "sessionId",
          },
        },
        streams: {
          name: "streams",
          isArray: true,
          type: {
            model: "Stream",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "session",
          },
        },
        sessionJudges: {
          name: "sessionJudges",
          isArray: true,
          type: {
            model: "SessionJudge",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "session",
          },
        },
        sessionTeams: {
          name: "sessionTeams",
          isArray: true,
          type: {
            model: "SessionTeam",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "session",
          },
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        admins: {
          name: "admins",
          isArray: true,
          type: "String",
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
        },
        producers: {
          name: "producers",
          isArray: true,
          type: "String",
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
        },
        coaches: {
          name: "coaches",
          isArray: true,
          type: "String",
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
        },
        judges: {
          name: "judges",
          isArray: true,
          type: "String",
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
        },
        producer: {
          name: "producer",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        rotations: {
          name: "rotations",
          isArray: true,
          type: {
            model: "Rotation",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "session",
          },
        },
        rosters: {
          name: "rosters",
          isArray: true,
          type: {
            model: "SessionRoster",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "session",
          },
        },
        squads: {
          name: "squads",
          isArray: true,
          type: {
            model: "Squad",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "session",
          },
        },
        judgeAssignments: {
          name: "judgeAssignments",
          isArray: true,
          type: {
            model: "SessionJudgeAssignment",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "session",
          },
        },
        rtnId: {
          name: "rtnId",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        hostId: {
          name: "hostId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        hostType: {
          name: "hostType",
          isArray: false,
          type: {
            enum: "SessionHostType",
          },
          isRequired: false,
          attributes: [],
        },
        location: {
          name: "location",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        attendance: {
          name: "attendance",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Sessions",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "searchable",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "SessionsByHost",
            fields: ["hostId"],
            queryField: "SessionsByHost",
          },
        },
        {
          type: "key",
          properties: {
            name: "SessionByKey",
            fields: ["sessionKey"],
            queryField: "SessionByKey",
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                provider: "userPools",
                ownerField: "admins",
                allow: "owner",
                operations: ["read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read", "update"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
              {
                allow: "private",
                provider: "iam",
                operations: ["create", "update", "read"],
              },
            ],
          },
        },
      ],
    },
    Rotation: {
      name: "Rotation",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        session: {
          name: "session",
          isArray: false,
          type: {
            model: "Session",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionId",
          },
        },
        order: {
          name: "order",
          isArray: false,
          type: "Int",
          isRequired: true,
          attributes: [],
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "RotationStatus",
          },
          isRequired: true,
          attributes: [],
        },
        stages: {
          name: "stages",
          isArray: true,
          type: {
            model: "Stage",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "rotation",
          },
        },
      },
      syncable: true,
      pluralName: "Rotations",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "bySession",
            fields: ["sessionId", "id"],
          },
        },
        {
          type: "key",
          properties: {
            name: "SessionRotations",
            fields: ["sessionId"],
            queryField: "SessionRotations",
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Stage: {
      name: "Stage",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        rotation: {
          name: "rotation",
          isArray: false,
          type: {
            model: "Rotation",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "rotationId",
          },
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "StageStatus",
          },
          isRequired: true,
          attributes: [],
        },
        apparatus: {
          name: "apparatus",
          isArray: false,
          type: {
            enum: "GymApparatus",
          },
          isRequired: true,
          attributes: [],
        },
        judges: {
          name: "judges",
          isArray: true,
          type: {
            model: "StageJudge",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "stage",
          },
        },
        routines: {
          name: "routines",
          isArray: true,
          type: {
            model: "Routine",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "stage",
          },
        },
        squad: {
          name: "squad",
          isArray: false,
          type: {
            model: "Squad",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "squadId",
          },
        },
        streams: {
          name: "streams",
          isArray: true,
          type: {
            model: "StageStream",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "stage",
          },
        },
      },
      syncable: true,
      pluralName: "Stages",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byRotation",
            fields: ["rotationId", "id"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    StageStream: {
      name: "StageStream",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        rotationId: {
          name: "rotationId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        stage: {
          name: "stage",
          isArray: false,
          type: {
            model: "Stage",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "stageId",
          },
        },
        stream: {
          name: "stream",
          isArray: false,
          type: {
            model: "Stream",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "streamId",
          },
        },
      },
      syncable: true,
      pluralName: "StageStreams",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byStage",
            fields: ["stageId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byStream",
            fields: ["streamId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    StageJudge: {
      name: "StageJudge",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        rotationId: {
          name: "rotationId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        stage: {
          name: "stage",
          isArray: false,
          type: {
            model: "Stage",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "stageId",
          },
        },
        sessionJudgeAssignment: {
          name: "sessionJudgeAssignment",
          isArray: false,
          type: {
            model: "SessionJudgeAssignment",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionJudgeAssignmentId",
          },
        },
        scoreTypes: {
          name: "scoreTypes",
          isArray: true,
          type: {
            enum: "ScoreType",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: false,
        },
      },
      syncable: true,
      pluralName: "StageJudges",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byStage",
            fields: ["stageId", "id"],
          },
        },
        {
          type: "key",
          properties: {
            name: "bySessionJudgeAssignment",
            fields: ["sessionJudgeAssignmentId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Squad: {
      name: "Squad",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        session: {
          name: "session",
          isArray: false,
          type: {
            model: "Session",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionId",
          },
        },
        rosters: {
          name: "rosters",
          isArray: true,
          type: {
            model: "SessionRoster",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "squad",
          },
        },
        name: {
          name: "name",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Squads",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "bySession",
            fields: ["sessionId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    LineupMember: {
      name: "LineupMember",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        sessionRoster: {
          name: "sessionRoster",
          isArray: false,
          type: {
            model: "SessionRoster",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionRosterId",
          },
        },
        athleteContext: {
          name: "athleteContext",
          isArray: false,
          type: {
            model: "AthleteContext",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "athleteContextId",
          },
        },
        apparatus: {
          name: "apparatus",
          isArray: false,
          type: {
            enum: "GymApparatus",
          },
          isRequired: true,
          attributes: [],
        },
        position: {
          name: "position",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        routine: {
          name: "routine",
          isArray: false,
          type: {
            model: "Routine",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "routineId",
          },
        },
      },
      syncable: true,
      pluralName: "LineupMembers",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "bySessionRoster",
            fields: ["sessionRosterId", "apparatus", "position"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    AthleteContext: {
      name: "AthleteContext",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        athlete: {
          name: "athlete",
          isArray: false,
          type: {
            model: "Athlete",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "athleteId",
          },
        },
        rosters: {
          name: "rosters",
          isArray: true,
          type: {
            model: "RosterAthleteContext",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "athleteContext",
          },
        },
        level: {
          name: "level",
          isArray: false,
          type: {
            enum: "AthleteContextLevel",
          },
          isRequired: true,
          attributes: [],
        },
        division: {
          name: "division",
          isArray: false,
          type: {
            enum: "AthleteContextDivision",
          },
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "AthleteContexts",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byAthlete",
            fields: ["athleteId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    RosterLink: {
      name: "RosterLink",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        roster: {
          name: "roster",
          isArray: false,
          type: {
            model: "Roster",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "rosterId",
          },
        },
        athlete: {
          name: "athlete",
          isArray: false,
          type: {
            model: "Athlete",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "athleteId",
          },
        },
        classYear: {
          name: "classYear",
          isArray: false,
          type: {
            enum: "ClassYear",
          },
          isRequired: false,
          attributes: [],
        },
        position: {
          name: "position",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        active: {
          name: "active",
          isArray: false,
          type: "Boolean",
          isRequired: true,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "RosterLinks",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "RosterLinkRoster",
            fields: ["rosterId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "RosterLinkAthlete",
            fields: ["athleteId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Athlete: {
      name: "Athlete",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        rosters: {
          name: "rosters",
          isArray: true,
          type: {
            model: "RosterLink",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "athlete",
          },
        },
        teamAffiliations: {
          name: "teamAffiliations",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        userId: {
          name: "userId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        gender: {
          name: "gender",
          isArray: false,
          type: {
            enum: "GenderType",
          },
          isRequired: false,
          attributes: [],
        },
        name: {
          name: "name",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        firstName: {
          name: "firstName",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        lastName: {
          name: "lastName",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        birthday: {
          name: "birthday",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        homeTown: {
          name: "homeTown",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        country: {
          name: "country",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        profileImg: {
          name: "profileImg",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        altNames: {
          name: "altNames",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        slug: {
          name: "slug",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        type: {
          name: "type",
          isArray: false,
          type: {
            enum: "LeagueType",
          },
          isRequired: false,
          attributes: [],
        },
        colors: {
          name: "colors",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "AthleteStatus",
          },
          isRequired: false,
          attributes: [],
        },
        contexts: {
          name: "contexts",
          isArray: true,
          type: {
            model: "AthleteContext",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "athlete",
          },
        },
        rtnId: {
          name: "rtnId",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Athletes",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "searchable",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    TeamCoach: {
      name: "TeamCoach",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        team: {
          name: "team",
          isArray: false,
          type: {
            model: "Team",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "teamId",
          },
        },
        user: {
          name: "user",
          isArray: false,
          type: {
            model: "User",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "userId",
          },
        },
      },
      syncable: true,
      pluralName: "TeamCoaches",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "TeamCoaches",
            fields: ["teamId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "UserCoaches",
            fields: ["userId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Judge: {
      name: "Judge",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        name: {
          name: "name",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        womensBrevet: {
          name: "womensBrevet",
          isArray: false,
          type: "Boolean",
          isRequired: true,
          attributes: [],
        },
        womensNational: {
          name: "womensNational",
          isArray: false,
          type: "Boolean",
          isRequired: true,
          attributes: [],
        },
        womensLevel10: {
          name: "womensLevel10",
          isArray: false,
          type: "Boolean",
          isRequired: true,
          attributes: [],
        },
        mensBrevet: {
          name: "mensBrevet",
          isArray: false,
          type: "Boolean",
          isRequired: true,
          attributes: [],
        },
        mensOptional: {
          name: "mensOptional",
          isArray: false,
          type: "Boolean",
          isRequired: true,
          attributes: [],
        },
        mensCompulsory: {
          name: "mensCompulsory",
          isArray: false,
          type: "Boolean",
          isRequired: true,
          attributes: [],
        },
        sessionAssignments: {
          name: "sessionAssignments",
          isArray: true,
          type: {
            model: "SessionJudgeAssignment",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "judge",
          },
        },
      },
      syncable: true,
      pluralName: "Judges",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "searchable",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    SessionJudgeAssignment: {
      name: "SessionJudgeAssignment",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        session: {
          name: "session",
          isArray: false,
          type: {
            model: "Session",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionId",
          },
        },
        judge: {
          name: "judge",
          isArray: false,
          type: {
            model: "Judge",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "judgeId",
          },
        },
        stages: {
          name: "stages",
          isArray: true,
          type: {
            model: "StageJudge",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "sessionJudgeAssignment",
          },
        },
      },
      syncable: true,
      pluralName: "SessionJudgeAssignments",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "bySession",
            fields: ["sessionId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byJudge",
            fields: ["judgeId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    SessionJudge: {
      name: "SessionJudge",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        session: {
          name: "session",
          isArray: false,
          type: {
            model: "Session",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionId",
          },
        },
        user: {
          name: "user",
          isArray: false,
          type: {
            model: "User",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "userId",
          },
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "AffiliationStatus",
          },
          isRequired: true,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "SessionJudges",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "SessionJudges",
            fields: ["sessionId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "UserJudges",
            fields: ["userId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Team: {
      name: "Team",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        name: {
          name: "name",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        slug: {
          name: "slug",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        location: {
          name: "location",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        altNames: {
          name: "altNames",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        gender: {
          name: "gender",
          isArray: false,
          type: {
            enum: "GenderType",
          },
          isRequired: true,
          attributes: [],
        },
        colors: {
          name: "colors",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        logos: {
          name: "logos",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        type: {
          name: "type",
          isArray: false,
          type: {
            enum: "LeagueType",
          },
          isRequired: true,
          attributes: [],
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "TeamStatus",
          },
          isRequired: false,
          attributes: [],
        },
        rosters: {
          name: "rosters",
          isArray: true,
          type: {
            model: "Roster",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "team",
          },
        },
        lineups: {
          name: "lineups",
          isArray: true,
          type: {
            model: "Lineup",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "team",
          },
        },
        coaches: {
          name: "coaches",
          isArray: true,
          type: {
            model: "TeamCoach",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "team",
          },
        },
        leagues: {
          name: "leagues",
          isArray: true,
          type: {
            model: "LeagueTeam",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "team",
          },
        },
        sessions: {
          name: "sessions",
          isArray: true,
          type: {
            model: "SessionTeam",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "team",
          },
        },
        rtnId: {
          name: "rtnId",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        triCode: {
          name: "triCode",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Teams",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "searchable",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    SessionTeam: {
      name: "SessionTeam",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        session: {
          name: "session",
          isArray: false,
          type: {
            model: "Session",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionId",
          },
        },
        team: {
          name: "team",
          isArray: false,
          type: {
            model: "Team",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "teamId",
          },
        },
        order: {
          name: "order",
          isArray: false,
          type: "Int",
          isRequired: true,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "SessionTeams",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "SessionTeams",
            fields: ["sessionId", "order"],
            queryField: "SessionTeamsBySessionByOrder",
          },
        },
        {
          type: "key",
          properties: {
            name: "TeamSessions",
            fields: ["teamId", "order"],
            queryField: "SessionTeamsByTeamByOrder",
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    League: {
      name: "League",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        name: {
          name: "name",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        altNames: {
          name: "altNames",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        slug: {
          name: "slug",
          isArray: false,
          type: "String",
          isRequired: true,
          attributes: [],
        },
        colors: {
          name: "colors",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        logos: {
          name: "logos",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        teams: {
          name: "teams",
          isArray: true,
          type: {
            model: "LeagueTeam",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "league",
          },
        },
        type: {
          name: "type",
          isArray: false,
          type: {
            enum: "LeagueType",
          },
          isRequired: true,
          attributes: [],
        },
        gender: {
          name: "gender",
          isArray: false,
          type: {
            enum: "GenderType",
          },
          isRequired: true,
          attributes: [],
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "LeagueStatus",
          },
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Leagues",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "searchable",
          properties: {},
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    LeagueTeam: {
      name: "LeagueTeam",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        league: {
          name: "league",
          isArray: false,
          type: {
            model: "League",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "leagueId",
          },
        },
        team: {
          name: "team",
          isArray: false,
          type: {
            model: "Team",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "teamId",
          },
        },
      },
      syncable: true,
      pluralName: "LeagueTeams",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "LeagueTeams",
            fields: ["leagueId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "TeamLeagues",
            fields: ["teamId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Score: {
      name: "Score",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        routine: {
          name: "routine",
          isArray: false,
          type: {
            model: "Routine",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "routineId",
          },
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: true,
          attributes: [],
        },
        value: {
          name: "value",
          isArray: false,
          type: "Int",
          isRequired: true,
          attributes: [],
        },
        type: {
          name: "type",
          isArray: false,
          type: {
            enum: "ScoreType",
          },
          isRequired: false,
          attributes: [],
        },
        userId: {
          name: "userId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        locked: {
          name: "locked",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Scores",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byRoutine",
            fields: ["routineId", "createdAt"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Penalty: {
      name: "Penalty",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        teamId: {
          name: "teamId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        lineup: {
          name: "lineup",
          isArray: false,
          type: {
            model: "Lineup",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "lineupId",
          },
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: true,
          attributes: [],
        },
        rotationId: {
          name: "rotationId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        value: {
          name: "value",
          isArray: false,
          type: "Int",
          isRequired: true,
          attributes: [],
        },
        type: {
          name: "type",
          isArray: false,
          type: {
            enum: "PenaltyType",
          },
          isRequired: false,
          attributes: [],
        },
        userId: {
          name: "userId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        locked: {
          name: "locked",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        notes: {
          name: "notes",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        valueType: {
          name: "valueType",
          isArray: false,
          type: {
            enum: "ScoreValueType",
          },
          isRequired: false,
          attributes: [],
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "PenaltyStatus",
          },
          isRequired: true,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Penalties",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byLineup",
            fields: ["lineupId", "createdAt"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read", "update"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Roster: {
      name: "Roster",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        team: {
          name: "team",
          isArray: false,
          type: {
            model: "Team",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "teamId",
          },
        },
        athletes: {
          name: "athletes",
          isArray: true,
          type: {
            model: "RosterLink",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "roster",
          },
        },
        athleteContexts: {
          name: "athleteContexts",
          isArray: true,
          type: {
            model: "RosterAthleteContext",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "roster",
          },
        },
        sessions: {
          name: "sessions",
          isArray: true,
          type: {
            model: "SessionRoster",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "roster",
          },
        },
        activeDate: {
          name: "activeDate",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        archived: {
          name: "archived",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        title: {
          name: "title",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        default: {
          name: "default",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Rosters",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "TeamRosters",
            fields: ["teamId", "activeDate"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    RosterAthleteContext: {
      name: "RosterAthleteContext",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        roster: {
          name: "roster",
          isArray: false,
          type: {
            model: "Roster",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "rosterId",
          },
        },
        athleteContext: {
          name: "athleteContext",
          isArray: false,
          type: {
            model: "AthleteContext",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "athleteContextId",
          },
        },
      },
      syncable: true,
      pluralName: "RosterAthleteContexts",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byRoster",
            fields: ["rosterId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byAthleteContext",
            fields: ["athleteContextId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read", "update"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    SessionRoster: {
      name: "SessionRoster",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        roster: {
          name: "roster",
          isArray: false,
          type: {
            model: "Roster",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "rosterId",
          },
        },
        session: {
          name: "session",
          isArray: false,
          type: {
            model: "Session",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionId",
          },
        },
        squad: {
          name: "squad",
          isArray: false,
          type: {
            model: "Squad",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "squadId",
          },
        },
        squadStartPosition: {
          name: "squadStartPosition",
          isArray: false,
          type: "Int",
          isRequired: false,
          attributes: [],
        },
        lineup: {
          name: "lineup",
          isArray: true,
          type: {
            model: "LineupMember",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "sessionRoster",
          },
        },
        lineupId: {
          name: "lineupId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "SessionRosters",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byRoster",
            fields: ["rosterId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "bySession",
            fields: ["sessionId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byLineup",
            fields: ["lineupId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "bySquad",
            fields: ["squadId", "squadStartPosition"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read", "update"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Lineup: {
      name: "Lineup",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        team: {
          name: "team",
          isArray: false,
          type: {
            model: "Team",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "teamId",
          },
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        eventId: {
          name: "eventId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        order: {
          name: "order",
          isArray: false,
          type: "Int",
          isRequired: false,
          attributes: [],
        },
        routines: {
          name: "routines",
          isArray: true,
          type: {
            model: "Routine",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "lineup",
          },
        },
        title: {
          name: "title",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        colors: {
          name: "colors",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        logos: {
          name: "logos",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        lineupData: {
          name: "lineupData",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        sessionTeamId: {
          name: "sessionTeamId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        forceTitle: {
          name: "forceTitle",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        individuals: {
          name: "individuals",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        penalties: {
          name: "penalties",
          isArray: true,
          type: {
            model: "Penalty",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "lineup",
          },
        },
      },
      syncable: true,
      pluralName: "Lineups",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "TeamLineups",
            fields: ["teamId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "SessionLineups",
            fields: ["sessionId"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byEvent",
            fields: ["eventId", "order", "id"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read", "update"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Stream: {
      name: "Stream",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        streamId: {
          name: "streamId",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        ingestURL: {
          name: "ingestURL",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        outputURL: {
          name: "outputURL",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        tempOutputURL: {
          name: "tempOutputURL",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        vodURL: {
          name: "vodURL",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        recordingURL: {
          name: "recordingURL",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        recordingId: {
          name: "recordingId",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        sessionKey: {
          name: "sessionKey",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        session: {
          name: "session",
          isArray: false,
          type: {
            model: "Session",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionId",
          },
        },
        index: {
          name: "index",
          isArray: false,
          type: "Int",
          isRequired: false,
          attributes: [],
        },
        meta: {
          name: "meta",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        stats: {
          name: "stats",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        error: {
          name: "error",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "StreamStatus",
          },
          isRequired: true,
          attributes: [],
        },
        vodMeta: {
          name: "vodMeta",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        recordingMeta: {
          name: "recordingMeta",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        owner: {
          name: "owner",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        type: {
          name: "type",
          isArray: false,
          type: {
            enum: "StreamType",
          },
          isRequired: false,
          attributes: [],
        },
        title: {
          name: "title",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        stages: {
          name: "stages",
          isArray: true,
          type: {
            model: "StageStream",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "stream",
          },
        },
      },
      syncable: true,
      pluralName: "Streams",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "SessionStreams",
            fields: ["sessionId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
              {
                allow: "private",
                provider: "iam",
                operations: ["create", "update", "read"],
              },
            ],
          },
        },
      ],
    },
    Overlay: {
      name: "Overlay",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        routineId: {
          name: "routineId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        clipId: {
          name: "clipId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        stream: {
          name: "stream",
          isArray: false,
          type: {
            model: "Stream",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "streamId",
          },
        },
        sessionKey: {
          name: "sessionKey",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        session: {
          name: "session",
          isArray: false,
          type: {
            model: "Session",
          },
          isRequired: true,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "sessionId",
          },
        },
        command: {
          name: "command",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
        delay: {
          name: "delay",
          isArray: false,
          type: "Int",
          isRequired: false,
          attributes: [],
        },
        displayAt: {
          name: "displayAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Overlays",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "StreamOverlays",
            fields: ["streamId", "displayAt", "createdAt"],
            queryField: "StreamOverlays",
          },
        },
        {
          type: "key",
          properties: {
            name: "SessionOverlays",
            fields: ["sessionId", "displayAt", "createdAt"],
            queryField: "SessionOverlays",
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
              {
                allow: "private",
                provider: "iam",
                operations: ["create", "update", "read"],
              },
            ],
          },
        },
      ],
    },
    Clip: {
      name: "Clip",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        routine: {
          name: "routine",
          isArray: false,
          type: {
            model: "Routine",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "routineId",
          },
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        streamId: {
          name: "streamId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        seekStartSeconds: {
          name: "seekStartSeconds",
          isArray: false,
          type: "Float",
          isRequired: false,
          attributes: [],
        },
        seekEndSeconds: {
          name: "seekEndSeconds",
          isArray: false,
          type: "Float",
          isRequired: false,
          attributes: [],
        },
        startTime: {
          name: "startTime",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        endTime: {
          name: "endTime",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        pgmStartTime: {
          name: "pgmStartTime",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        pgmEndTime: {
          name: "pgmEndTime",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        duration: {
          name: "duration",
          isArray: false,
          type: "Float",
          isRequired: false,
          attributes: [],
        },
        fileName: {
          name: "fileName",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        originURL: {
          name: "originURL",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        owner: {
          name: "owner",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        type: {
          name: "type",
          isArray: false,
          type: {
            enum: "ClipType",
          },
          isRequired: true,
          attributes: [],
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "ClipStatus",
          },
          isRequired: true,
          attributes: [],
        },
        location: {
          name: "location",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        resolution: {
          name: "resolution",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        fps: {
          name: "fps",
          isArray: false,
          type: "Float",
          isRequired: false,
          attributes: [],
        },
        bitrate: {
          name: "bitrate",
          isArray: false,
          type: "Int",
          isRequired: false,
          attributes: [],
        },
        fileSize: {
          name: "fileSize",
          isArray: false,
          type: "Int",
          isRequired: false,
          attributes: [],
        },
        source: {
          name: "source",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        codecs: {
          name: "codecs",
          isArray: false,
          type: "String",
          isRequired: false,
          attributes: [],
        },
        other: {
          name: "other",
          isArray: false,
          type: "AWSJSON",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Clips",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "RoutineClips",
            fields: ["routineId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["read"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Routine: {
      name: "Routine",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        clips: {
          name: "clips",
          isArray: true,
          type: {
            model: "Clip",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "routine",
          },
        },
        rotationId: {
          name: "rotationId",
          isArray: false,
          type: "ID",
          isRequired: false,
          attributes: [],
        },
        stage: {
          name: "stage",
          isArray: false,
          type: {
            model: "Stage",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "stageId",
          },
        },
        athlete: {
          name: "athlete",
          isArray: false,
          type: {
            model: "Athlete",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "athleteId",
          },
        },
        athleteContext: {
          name: "athleteContext",
          isArray: false,
          type: {
            model: "AthleteContext",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "athleteContextId",
          },
        },
        apparatus: {
          name: "apparatus",
          isArray: false,
          type: {
            enum: "GymApparatus",
          },
          isRequired: false,
          attributes: [],
        },
        order: {
          name: "order",
          isArray: false,
          type: "Int",
          isRequired: false,
          attributes: [],
        },
        rotation: {
          name: "rotation",
          isArray: false,
          type: "Int",
          isRequired: false,
          attributes: [],
        },
        lineup: {
          name: "lineup",
          isArray: false,
          type: {
            model: "Lineup",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "lineupId",
          },
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "RoutineStatus",
          },
          isRequired: true,
          attributes: [],
        },
        score: {
          name: "score",
          isArray: false,
          type: "Float",
          isRequired: false,
          attributes: [],
        },
        scores: {
          name: "scores",
          isArray: true,
          type: {
            model: "Score",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "routine",
          },
        },
        inquiries: {
          name: "inquiries",
          isArray: true,
          type: {
            model: "Inquiry",
          },
          isRequired: false,
          attributes: [],
          isArrayNullable: true,
          association: {
            connectionType: "HAS_MANY",
            associatedWith: "routine",
          },
        },
        isEdited: {
          name: "isEdited",
          isArray: false,
          type: "Boolean",
          isRequired: false,
          attributes: [],
        },
        createdAt: {
          name: "createdAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        startedAt: {
          name: "startedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        completedAt: {
          name: "completedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
        updatedAt: {
          name: "updatedAt",
          isArray: false,
          type: "AWSDateTime",
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Routines",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "SessionRoutines",
            fields: ["sessionId"],
            queryField: "SessionRoutines",
          },
        },
        {
          type: "key",
          properties: {
            name: "LineupRoutines",
            fields: ["lineupId", "order", "id"],
          },
        },
        {
          type: "key",
          properties: {
            name: "byStage",
            fields: ["stageId", "order"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["create", "read", "update"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["create", "read", "update"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
    Inquiry: {
      name: "Inquiry",
      fields: {
        id: {
          name: "id",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        sessionId: {
          name: "sessionId",
          isArray: false,
          type: "ID",
          isRequired: true,
          attributes: [],
        },
        routine: {
          name: "routine",
          isArray: false,
          type: {
            model: "Routine",
          },
          isRequired: false,
          attributes: [],
          association: {
            connectionType: "BELONGS_TO",
            targetName: "routineId",
          },
        },
        status: {
          name: "status",
          isArray: false,
          type: {
            enum: "InquiryStatus",
          },
          isRequired: false,
          attributes: [],
        },
      },
      syncable: true,
      pluralName: "Inquiries",
      attributes: [
        {
          type: "model",
          properties: {},
        },
        {
          type: "aws_cognito_user_pools",
          properties: {},
        },
        {
          type: "key",
          properties: {
            name: "byRoutine",
            fields: ["routineId"],
          },
        },
        {
          type: "auth",
          properties: {
            rules: [
              {
                allow: "public",
                operations: ["read"],
              },
              {
                provider: "userPools",
                ownerField: "owner",
                allow: "owner",
                operations: ["create", "read", "update"],
                identityClaim: "cognito:username",
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["user"],
                operations: ["create", "read", "update"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["poweruser"],
                operations: ["create", "read", "update"],
              },
              {
                groupClaim: "cognito:groups",
                provider: "userPools",
                allow: "groups",
                groups: ["admin"],
                operations: ["create", "read", "update", "delete"],
              },
            ],
          },
        },
      ],
    },
  },
  enums: {
    JudgeType: {
      name: "JudgeType",
      values: [
        "FIG_MENS",
        "FIG_WOMENS",
        "NCAA_MENS",
        "NCAA_WOMENS",
        "JO_MENS",
        "JO_WOMENS",
      ],
    },
    UserStatus: {
      name: "UserStatus",
      values: ["CREATED", "VERIFIED", "WAITLIST", "ACTIVE", "DELETED"],
    },
    SessionHostType: {
      name: "SessionHostType",
      values: ["NONE", "TEAM", "USER"],
    },
    SessionAccess: {
      name: "SessionAccess",
      values: ["PRIVATE", "PUBLIC", "KEY", "GUESTLIST"],
    },
    SessionStatus: {
      name: "SessionStatus",
      values: [
        "CREATED",
        "PREGAME",
        "LIVE",
        "POSTGAME",
        "ARCHIVED",
        "CANCELED",
        "DELETED",
      ],
    },
    SessionType: {
      name: "SessionType",
      values: ["SOLO", "DUAL", "MULTI"],
    },
    SessionTeamScoreType: {
      name: "SessionTeamScoreType",
      values: [
        "TOP5OF6",
        "TOP6HL",
        "TOP6",
        "TOP5",
        "TOP4",
        "TOP3",
        "BEST5",
        "BEST4",
        "BEST3",
        "ALL",
        "NONE",
      ],
    },
    JudgePanelType: {
      name: "JudgePanelType",
      values: [
        "NCAAM",
        "NCAAM4",
        "NCAAW",
        "NCAAW2",
        "NCAAW2SV",
        "NCAAW4",
        "NCAAW6",
        "FIG4",
        "FIG5",
        "FIG6",
        "FAN",
        "SINGLE",
        "J4",
        "OPEN",
      ],
    },
    RotationStatus: {
      name: "RotationStatus",
      values: ["CREATED", "ACTIVE", "COMPLETE"],
    },
    StageStatus: {
      name: "StageStatus",
      values: ["CREATED", "ACTIVE", "COMPLETE"],
    },
    AthleteContextLevel: {
      name: "AthleteContextLevel",
      values: ["JO", "ELITE", "COLLEGE"],
    },
    AthleteContextDivision: {
      name: "AthleteContextDivision",
      values: [
        "C_FR",
        "C_RFR",
        "C_SO",
        "C_RSO",
        "C_JR",
        "C_RJR",
        "C_SR",
        "C_RSR",
        "JO_10",
        "JO_9",
        "JO_8",
        "JO_7",
        "JO_6",
        "JO_5",
        "JO_4",
        "JO_3",
        "JO_2",
        "JO_1",
      ],
    },
    AthleteStatus: {
      name: "AthleteStatus",
      values: ["ACTIVE", "INACTIVE", "DELETED"],
    },
    GenderType: {
      name: "GenderType",
      values: ["MALE", "FEMALE", "COED"],
    },
    AffiliationStatus: {
      name: "AffiliationStatus",
      values: ["ACTIVE", "INACTIVE"],
    },
    TeamStatus: {
      name: "TeamStatus",
      values: ["ACTIVE", "INACTIVE", "DELETED"],
    },
    LeagueStatus: {
      name: "LeagueStatus",
      values: ["ACTIVE", "INACTIVE", "DELETED"],
    },
    LeagueType: {
      name: "LeagueType",
      values: ["FIG", "JO", "NCAA", "CLUB", "OTHER"],
    },
    ScoreType: {
      name: "ScoreType",
      values: [
        "D",
        "D1",
        "D2",
        "E",
        "E1",
        "E2",
        "E3",
        "E4",
        "E5",
        "E6",
        "F",
        "SB",
        "ND",
        "SV",
        "SV1",
        "SV2",
        "SV3",
        "SV4",
        "SV5",
        "SV6",
        "J",
        "J1",
        "J2",
        "J3",
        "J4",
        "J5",
        "J6",
        "OPEN",
      ],
    },
    ClassYear: {
      name: "ClassYear",
      values: [
        "RFR",
        "RSO",
        "RJR",
        "RSR",
        "FR",
        "SO",
        "JR",
        "SR",
        "ELT",
        "PFR",
        "RET",
      ],
    },
    PenaltyType: {
      name: "PenaltyType",
      values: ["NEUTRAL", "YELLOWCARD", "REDCARD"],
    },
    PenaltyStatus: {
      name: "PenaltyStatus",
      values: ["ISSUED", "OVERRULED", "CANCELED"],
    },
    ScoreValueType: {
      name: "ScoreValueType",
      values: ["MILLIPOINT", "INTEGER"],
    },
    StreamType: {
      name: "StreamType",
      values: ["CAMERA", "PRODUCTION"],
    },
    StreamStatus: {
      name: "StreamStatus",
      values: [
        "OFF",
        "STARTING",
        "STARTED",
        "STOPPING",
        "STOPPED",
        "RESETTING",
        "DELETING",
        "DELETED",
        "CREATING",
        "ERROR",
        "ARCHIVED",
      ],
    },
    ClipType: {
      name: "ClipType",
      values: ["LIVE", "VOD", "FILE", "LINK", "YOUTUBE", "OTHER"],
    },
    ClipStatus: {
      name: "ClipStatus",
      values: [
        "ACTIVE",
        "INACTIVE",
        "ARCHIVED",
        "DELETED",
        "PROCESSING",
        "UPLOADING",
      ],
    },
    RoutineStatus: {
      name: "RoutineStatus",
      values: ["ON_AIR", "ON_EVAL", "COMPLETE", "STANDBY", "DELETED"],
    },
    InquiryStatus: {
      name: "InquiryStatus",
      values: ["OPEN", "CLOSED", "CANCELED"],
    },
    GymApparatus: {
      name: "GymApparatus",
      values: [
        "FX",
        "PH",
        "SR",
        "VT",
        "PB",
        "HB",
        "UB",
        "BB",
        "WU",
        "WUFX",
        "WUPH",
        "WUSR",
        "WUVT",
        "WUPB",
        "WUHB",
        "WUUB",
        "WUBB",
        "BYE1",
        "BYE2",
        "BYE3",
        "BYE4",
        "BYE5",
        "BYE6",
        "BYE7",
      ],
    },
  },
  nonModels: {},
  codegenVersion: "3.4.4",
  version: "9072f5e98bc4b388899584e6f7bb5e6a",
};
